var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.291 16.646c.001 6.021-3.9 11.132-9.312 12.943.556-3.244 1.767-7.518 3.73-11.792 1.39-3.025 2.926-5.449 4.191-7.163a13.59 13.59 0 0 1 1.391 6.01zM15.647 3c4.81 0 9.04 2.49 11.47 6.252-2.358 5.247-7.154 9.756-12.18 12.887-2.91 1.812-7.08 2.362-10.414 2.41A13.583 13.583 0 0 1 2 16.647C2 9.109 8.11 3 15.646 3zm12.227 6.114V7.43L30 6.544v1.684l-2.127.886z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApx);
export default __webpack_public_path__ + "static/media/APX.2b38763e87e9cbec5ad81927ac17a7af.svg";
export { ForwardRef as ReactComponent };